import React, { useState } from 'react';
import styles from "./TweetInput.module.css";
import { auth, db, storage } from '../firebase';
import firebase from 'firebase/app';
import { useSelector } from 'react-redux';
import { selectUser } from '../features/userSlice';
import { Avatar, Button, IconButton } from '@material-ui/core';
import AddPhotoIcon from "@material-ui/icons/AddAPhoto";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  big: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginTop: theme.spacing(.2),
    "@media (max-width: 768px)": {
     width: 45,
     height: 45,
     marginTop: 5,
    },
    "@media (max-width: 480px)": {
     width: 40,
     height: 40,
     marginTop: 8,
    },
    "@media (max-width: 320px)": {
     width: 35,
     height: 35,
     marginTop: 10,
    }
  }
}))

const TweetInput: React.FC = () => {
  const classes = useStyles();
  const user = useSelector(selectUser);
  const [tweetImage, setTweetImage] = useState<File | null>(null);
  const [tweetMsg, setTweetMsg] = useState("");

  const onChangeImageHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files![0]) {
      setTweetImage(e.target.files![0]);
      e.target.value= "";
    }
  };
  const sendTweet = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (tweetImage) {
      const S = 'abcdefghijklmnopqrstuzwxyzABCDEFGHIJKLMNOPQRSTUZWXYZ0123456789';
      const N = 16;
      const randomChar = Array.from(crypto.getRandomValues(new Uint32Array(N))).map((n) => S[n % S.length]).join("");
      const fileName = randomChar + "_" + tweetImage.name;
      const uploadTweetImg = storage.ref(`images/${fileName}`).put(tweetImage);
      uploadTweetImg.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        () => {},
        (err) => {
          alert(err.message);
        }, async () => {
          await storage
          .ref("images")
          .child(fileName)
          .getDownloadURL()
          .then(
            async (url) => {
              await db.collection("posts").add({
                avatar: user.photoUrl,
                image: url,
                text: tweetMsg,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                username: user.displayName,
              });
            });
        }
      );

    } else {
      db.collection("posts").add({
        avatar: user.photoUrl,
        image: "",
        text: tweetMsg,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        username: user.displayName,
      });
    }
    setTweetImage(null);
    setTweetMsg("");
  };

  return (
    <>
    <form onSubmit={sendTweet}>
    <div className={styles.tweet_form}>
     <Avatar 
       className={classes.big}
       src={user.photoUrl}
       onClick={async () => {
         await auth.signOut();
       }}
     />
     <input
      className={styles.tweet_input}
      type="text"
      placeholder="What's happening?"
      autoFocus
      value={tweetMsg}
      onChange={(e) => setTweetMsg(e.target.value)}
      />
      
      <IconButton>
        <label>
          <AddPhotoIcon 
            className={
              tweetImage ? styles.tweet_addIconLoaded : styles.tweet_addIcon
            }
          />
        <input
        className={styles.tweet_hiddenIcon}
        type="file"
        onChange={onChangeImageHandler}
       />
        </label>
      </IconButton>
    <Button
      type="submit"
      disabled={!tweetMsg}
      className={
        tweetMsg ? styles.tweet_sendBtn : styles.tweet_sendDisableBtn
      }
      >
        Tweet
    </Button>
    </div>

    </form>
    </>
  );
}

export default TweetInput;
